module.exports = __webpack_public_path__ + "media/luxury-2026/drone-video-interior-539d6719.jpg";